export const initHash = () => {
	window.addEventListener(`hashchange`, (evt) => {
		const hash = location.hash.split( `/` );
		
		if ( hash[0] === `#lightbox` )
		{
			
		}
	});

	/*trigger(window, `hashchange`);*/
};
